import { useContext } from 'react';
import './PageTraitsPersonnalite.css';
import { SlidesContext } from '../../contexts/SlidesContext';
import messages from '../../lang/preferences';
import ReviewFormattedMessage from '../../generics/ReviewFormattedMessage';

export default function PageTraitsPersonnalite ( {slide} ) {
  const { slidesAnswers, updateValues } = useContext(SlidesContext);

  const handleChange = (event) => {
    const value = parseInt(event.target.value, 10);
    updateValues(slide.inputNumber, slide.key, value);
  }
  const _changeLabel = () => {
    if (slidesAnswers[slide.inputNumber][slide.key] === -98 || slidesAnswers[slide.inputNumber][slide.key] === 98){
      return slide.labelLvl[3].labelTP;
    }
    else if((slidesAnswers[slide.inputNumber][slide.key] === -70 || slidesAnswers[slide.inputNumber][slide.key] === 70)){
      return slide.labelLvl[2].labelTP;
    }
    else if((slidesAnswers[slide.inputNumber][slide.key] === -42 || slidesAnswers[slide.inputNumber][slide.key] === 42)){
      return slide.labelLvl[1].labelTP;
    }
    else if((slidesAnswers[slide.inputNumber][slide.key] === -14 || slidesAnswers[slide.inputNumber][slide.key] === 14)){
      return slide.labelLvl[0].labelTP;
    }
    else {
      return slide.labelDefault;
    }
  }
  /*const _changeColor = () => {
    if (slide[step].value < 0){
      return 'primary';
    }
    else if(slide[step].value > 0){
      return 'default'
    }
    else {
      return 'dark'
    }
  }*/
  return (
    <div className="PageTP animated fadeInRight animate__animated animate__fadeInRight">
      <div className="PageTP-container-box">
        <span className="Slide-help">
          <ReviewFormattedMessage descriptor={messages.TRAITSPERSONNALITEINSTRUCTION}/>
        </span>
        <div className="PageTP-boxes">
          <div className="PageTP-box boxL">
            <p>
              <ReviewFormattedMessage descriptor={slide.leftTraitPersonnalite} />
            </p>
          </div>
          <div className="PageTP-box boxR">
            <p>
              <ReviewFormattedMessage descriptor={slide.rightTraitPersonnalite} />
            </p>
          </div>
        </div>
      </div>
      <span className="PageTP-label">
        <ReviewFormattedMessage descriptor={_changeLabel()} />
      </span>
      <div className="PTP_slider2">
        <div>
          <input className="PTP_hidden PTP_radio-label PTP_choice-button" type="radio" value="-98" id={"-rb0"} name={slide.key} onChange={handleChange} checked={slidesAnswers[slide.inputNumber][slide.key] === -98}  />
          <label className="PTP_button-label PTP_size5" htmlFor={"-rb0"}>O</label>
        </div>
        <div>
          <input className="PTP_hidden PTP_radio-label PTP_choice-button" type="radio"  value="-70" id={"-rb1"} name={slide.key} onChange={handleChange} checked={slidesAnswers[slide.inputNumber][slide.key] === -70} />
          <label className="PTP_button-label PTP_size4" htmlFor={"-rb1"} >O</label>
        </div>
        <div>
          <input className="PTP_hidden PTP_radio-label PTP_choice-button" type="radio"  value="-42" id={"-rb2"} name={slide.key} onChange={handleChange} checked={slidesAnswers[slide.inputNumber][slide.key] === -42} />
          <label className="PTP_button-label PTP_size3" htmlFor={"-rb2"} >O</label>
        </div>
        <div>
          <input className="PTP_hidden PTP_radio-label PTP_choice-button" type="radio"  value="-14" id={"-rb3"} name={slide.key} onChange={handleChange} checked={slidesAnswers[slide.inputNumber][slide.key] === -14} />
          <label className="PTP_button-label PTP_size2" htmlFor={"-rb3"} >O</label>
        </div>
        <div>
          <input className="PTP_hidden PTP_radio-label PTP_choice-button_Right" type="radio"  value="14" id={"-rb4"} name={slide.key} onChange={handleChange} checked={slidesAnswers[slide.inputNumber][slide.key] === 14} />
          <label className="PTP_button-label PTP_size2" htmlFor={"-rb4"} >O</label>
        </div>
        <div>
          <input className="PTP_hidden PTP_radio-label PTP_choice-button_Right" type="radio"  value="42" id={"-rb5"} name={slide.key} onChange={handleChange} checked={slidesAnswers[slide.inputNumber][slide.key] === 42} />
          <label className="PTP_button-label PTP_size3" htmlFor={"-rb5"} >O</label>
        </div>
        <div>
          <input className="PTP_hidden PTP_radio-label PTP_choice-button_Right" type="radio"  value="70" id={"-rb6"} name={slide.key} onChange={handleChange} checked={slidesAnswers[slide.inputNumber][slide.key] === 70} />
          <label className="PTP_button-label PTP_size4" htmlFor={"-rb6"} >O</label>
        </div>
        <div>
          <input className="PTP_hidden PTP_radio-label PTP_choice-button_Right" type="radio"  value="98" id={"-rb7"} name={slide.key} onChange={handleChange} checked={slidesAnswers[slide.inputNumber][slide.key] === 98} />
          <label className="PTP_button-label PTP_size5" htmlFor={"-rb7"} >O</label>
        </div>
      </div>
    </div>
  );
}


